<template src="./template.html"></template>

<script>
import { mapState } from 'vuex'
import notificationMixin from 'src/mixins/notificationMixin'
import masterMixin from 'src/mixins/masterMixin'
import tantoujimushoApi from 'src/apis/masters/tantoujimusho'

const api = tantoujimushoApi
const displayPageName = '担当事務所'
const msgVars = { create: '作成', update: '編集' }

export default {
  displayPageName: displayPageName,
  data() {
    return {
      displayPageName: displayPageName,

      isReady: false,
      isRequesting: false,

      search: {
        detailGyoumuId: null,
      },
      origList: [],
      list: [],
      tenkengyoumuDetailCands: [],
      saveCandidate: {},
      showSaveModal: false,
      showPasswordModal: false,

      pagination: {
        currentPage: 1,
        itemsPerPage: 50,
      },
    }
  },
  computed: {
    ...mapState('user', {
      has_role_admin: state => state.has_role_admin,
    }),
    hasList() {
      return this.list.length > 0
    },
    paginatedList() {
      const nextPageIdx = this.pagination.currentPage * this.pagination.itemsPerPage
      const minIdx = nextPageIdx - this.pagination.itemsPerPage
      return this.list.filter((e, i) => {
        return i >= minIdx && i < nextPageIdx
      })
    },
  },
  async mounted() {
    await this.ensureUserAndMasters()
    if (!this.has_role_admin) {
      location.href = '/'
    }

    this.prepareMasters()
    this.prepareSearchParams()
    await this.getList()
    this.isReady = true
  },
  mixins: [notificationMixin, masterMixin],
  methods: {
    prepareMasters() {
      const master = window.master
      this.tenkengyoumuDetailCands = master.tenkengyoumu_detail.vals
    },
    prepareSearchParams() {
      const search = {
        detailGyoumuId: null,
      }
      if (this.tenkengyoumuDetailCands.length > 0) {
        search.detailGyoumuId = this.tenkengyoumuDetailCands[0].m_tenkengyoumu_detail_id
      }
      this.search = search
    },
    getItemForDisp(item) {
      // 開始時間(昼間)
      if (item.start_daytime) {
        const hm = item.start_daytime.split(':')
        item.start_daytime_h = hm[0]
        item.start_daytime_m = hm[1]
      }
      // 終了時間(昼間)
      if (item.end_daytime) {
        const hm = item.end_daytime.split(':')
        item.end_daytime_h = hm[0]
        item.end_daytime_m = hm[1]
      }
      // 開始時間(夜間)
      if (item.start_nighttime) {
        const hm = item.start_nighttime.split(':')
        item.start_nighttime_h = hm[0]
        item.start_nighttime_m = hm[1]
      }
      // 終了時間(夜間)
      if (item.end_nighttime) {
        const hm = item.end_nighttime.split(':')
        item.end_nighttime_h = hm[0]
        item.end_nighttime_m = hm[1]
      }
      return item
    },
    filterListBySearchParams() {
      this.pagination.currentPage = 1
      this.list = this.origList.filter(e => e.detail_gyoumu_id === this.search.detailGyoumuId)
    },
    async getList() {
      this.isRequesting = true
      try {
        const { data } = await tantoujimushoApi.index()
        this.origList = data.map(e => this.getItemForDisp(e))
        this.filterListBySearchParams()
        this.isRequesting = false
      } catch (err) {
        console.error('error', err)
        this.isRequesting = false
      }
    },
    openSaveModal(item) {
      let saveCandidate = {}
      if (!item) {
        saveCandidate.isNew = true
        saveCandidate.detail_gyoumu_id = this.search.detailGyoumuId
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        saveCandidate.start_date = today
        saveCandidate.end_date = new Date(2099, 12 - 1, 30)
      } else {
        saveCandidate = JSON.parse(JSON.stringify(item))
      }
      this.saveCandidate = saveCandidate
      this.showSaveModal = true
    },
    closeSaveModal() {
      this.saveCandidate = {}
      this.showSaveModal = false
    },
    getItemForReq() {
      const ret = this.saveCandidate

      // 開始時間(昼間)
      const startDaytimeHStr = ret.start_daytime_h
      const startDaytimeMStr = ret.start_daytime_m
      let startDaytime = null
      if (!!startDaytimeHStr && !!startDaytimeMStr) {
        startDaytime = `${startDaytimeHStr}:${startDaytimeMStr}`
      }
      ret.start_daytime = startDaytime

      // 終了時間(昼間)
      const endDaytimeHStr = ret.end_daytime_h
      const endDaytimeMStr = ret.end_daytime_m
      let endDaytime = null
      if (!!endDaytimeHStr && !!endDaytimeMStr) {
        endDaytime = `${endDaytimeHStr}:${endDaytimeMStr}`
      }
      ret.end_daytime = endDaytime

      // 開始時間(夜間)
      const startNighttimeHStr = ret.start_nighttime_h
      const startNighttimeMStr = ret.start_nighttime_m
      let startNighttime = null
      if (!!startNighttimeHStr && !!startNighttimeMStr) {
        startNighttime = `${startNighttimeHStr}:${startNighttimeMStr}`
      }
      ret.start_nighttime = startNighttime

      // 終了時間(夜間)
      const endNighttimeHStr = ret.end_nighttime_h
      const endNighttimeMStr = ret.end_nighttime_m
      let endNighttime = null
      if (!!endNighttimeHStr && !!endNighttimeMStr) {
        endNighttime = `${endNighttimeHStr}:${endNighttimeMStr}`
      }
      ret.end_nighttime = endNighttime

      return ret
    },
    async saveItem() {
      const isValid = await this.$refs.saveCandidate.validate()
      if (!isValid) { return }
      const opType = this.saveCandidate.isNew ? 'create' : 'update'
      try {
        const reqObj = {
          id: this.saveCandidate.id,
          data: this.getItemForReq(),
        }
        await api[opType](reqObj)
        await this.getList()
        this.closeSaveModal()
        this.notifySuccess1(`${displayPageName}を${msgVars[opType]}しました`)
      } catch (err) {
        const msg = `${displayPageName}の${msgVars[opType]}に失敗しました。` +
          '管理者に連絡してください。'
        this.notifyError1(msg, { err })
      }
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
